// @flow

const colors = {
  aliceBlue: '#edf2fb',
  antiFlashWhite: '#f2f3f5',
  aquamarine: '#7CF8AC',
  ashGrey: '#B0BEC5',
  azureishWhite: '#e1e7ee',
  benign: '#8B8B8E',
  black: '#000',
  blanchedAlmond: '#ffecd1',
  bleuDeFrance: '#25A0EB',
  blueGreen: '#149bb3',
  brightLilac: '#E28FF2',
  bulk: '#b5cbd1',
  bulkFrom: '#b5cbd1',
  bulkTo: '#b5cbd1',
  cadetGrey: '#90A4AE',
  darkSlateGray: '#2a4b72',
  deepSkyBlue: '#03bffe',
  deepSpaceSparkle: '#455a64',
  diamond: '#B3EBFE',
  dimGray: '#656A77',
  ebony: '#5d5d5d',
  gainsboro: '#d8e0ea',
  ghostWhite: '#f7fbff',
  glitter: '#E7E8EC',
  green: '#19a677',
  grayBlue: '#8F95a5',
  independence: '#4d5673',
  illuminatingEmerald: '#3B8C75',
  jet: '#333',
  lightGray: '#CCD1DC',
  lightSlateGray: '#7a8196',
  magicMint: '#9cf4dc',
  malicious: '#DC67AB',
  maliciousFrom: '#DC67AB',
  maliciousTo: '#DC67AB',
  maliciousBec: '#E07AB5',
  maliciousBecFrom: '#E07AB5',
  maliciousBecTo: '##E07AB5',
  manatee: '#989ca6',
  mauve: '#E4AFFF',
  maximumPurple: '#843280',
  mediumAquamarine: '#64CAAD',
  mellowYellow: '#FFDC82',
  middleBlueGreen: '#74E8C9',
  mineralGreen: '#3C5C5E',
  mystic: '#e1e7ee',
  neonCarrot: '#FFA94D',
  noDisposition: '#8B8B8E',
  onyx: '#383839',
  orchid: '#D968D3',
  parisGreen: '#4EC987',
  paleTurquoise: '#b2f5e5',
  papayaWhip: '#FFF3D6',
  peach: '#FFEAB5',
  pastelBlue: '#b8c1cf',
  pastelGray: '#cbcbcb',
  pastelRed: '#ff6969',
  pinkOrange: '#ff9169',
  platinum: '#e5e8ea',
  polishedPine: '#50A38B',
  pumpkin: '#FF8C1A',
  purpureus: '#A650A1',
  quarantineRelease: '#8B8B8E',
  raisinBlack: '#242425',
  redOrange: '#ff4f4f',
  rhythm: '#777f96',
  sonicSilver: '#797979',
  spam: '#6fa6bf',
  spamFrom: '#6fa6bf',
  spamTo: '#6fa6bf',
  spanishGray: '#929292',
  spoof: '#EBABD0',
  spoofFrom: '#EBABD0',
  spoofTo: '#EBABD0',
  starCommandBlue: '#1179B9',
  steelTeal: '#607D8B',
  sulu: '#B8F15F',
  sunglow: '#ffcc4d',
  suspicious: '#E58EC0',
  suspiciousFrom: '#E58EC0',
  suspiciousTo: '#E58EC0',
  topaz: '#FFC168',
  tuscanBrown: '#e7e8ec',
  vividSkyBlue: '#02d7ff',
  white: '#fff',
};

export default colors;
